/**
 * 中信银行
 */
import request from '@/utils/request'
// 获取 商户列表 增 删 改
export function arpaMerchant(params,method) {
  if(method==='get'){
    return request({
      url: '/ntocc-tms-api/arpaMerchant',
      method,
      params
      // data:params
    })
  }else{
    return request({
      url: '/ntocc-tms-api/arpaMerchant',
      method,
      // params
      data:params
    })
  }
  }
// 获取商户详细信息
export function getArpaMerchant(code, source) {
  return request({
    url: `/ntocc-tms-api/arpaMerchant/${code}`,
    method:'get',
    params: { source: source }
  })
}
  // 余额提现接口
  export function arpaWithdraw(query) {
    return request({
      url: '/ntocc-tms-api/arpaWithdraw',
      method: 'post',
      params: query
    })
  }

//  商户注册
export function registerMerchant(query) {
    return request({
      url: '/ntocc-tms-api/arpaMerchant/registerMerchant',
      method: 'put',
      params: query
    })
  }

  // 更新商户注册结果
  export function updateRegisterStatus(query) {
    return request({
      url: `/ntocc-tms-api/arpaMerchant/updateRegisterStatus`,
      method: 'put',
      params:query
    })
  }

  //  商户修改
export function updateMerchant(query) {
    return request({
      url: '/ntocc-tms-api/arpaMerchant/updateMerchant',
      method: 'put',
      params: query
    })
  }
// 修改商户基本信息
export function addArpaMerchant(query) {
    return request({
      url: '/ntocc-tms-api/arpaMerchant',
      method: 'post',
      params: query
    })
  }
// 获取基本信息
export function regMerPartyInfo(partyCode) {
  return request({
    url: `ntocc-tms-api/arpaMerchant/regMerPartyInfo/${partyCode}`,
    method: 'get',
  })
}
//商户余额

export function accountBalance(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/queryAccountBalance',
    method: 'put',
    params: query
  })
}
// 获取钱包信息
export function accountInfo(code) {
  return request({
    url: `ntocc-tms-api/arpaMerchant/accountInfo/${code}`,
    method: 'get',
  })
}

export function queryRechargeMerchant(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/queryRechargeMerchant',
    method: 'get',
    params: query
  })
}

export function merchantRecharge(data) {
  return request({
    url: '/ntocc-basic-api/shipmentPaidRecord/merchantRecharge',
    method: 'put',
    params: data
  })
}

// 绑定手机号 短信验证码接口
export function bindPhoneSendSms(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/bindPhoneSendSms',
    method: 'post',
    params: query
  })
}

// 解绑手机号 短信验证码接口
export function unbindPhoneSendSms(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/unbindPhoneSendSms',
    method: 'post',
    params: query
  })
}

// 绑定手机号
export function bindPhone(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/bindPhone',
    method: 'post',
    params: query
  })
}

// 解绑手机号
export function unbindPhone(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/unbindPhone',
    method: 'post',
    params: query
  })
}

// 提现协议签约
export function signProtocol(query) {
  return request({
    url: '/ntocc-tms-api/arpaMerchant/signProtocol',
    method: 'post',
    params: query
  })
}
